import { PACKAGE_CARD_TABS_KEYS } from 'frontend/constants'
import { usePackageCard } from 'frontend/contexts/PackageCardContext'
import { useTranslation } from 'react-i18next'
import { RiFlightTakeoffFill, RiHotelFill } from 'react-icons/ri'
import IconButton from '../IconButton'

const { FLIGHTS, HOTELS } = PACKAGE_CARD_TABS_KEYS

const iconsByTab = {
  [FLIGHTS]: RiFlightTakeoffFill,
  [HOTELS]: RiHotelFill,
}

const PackageCardButton = ({ tabKey }) => {
  const { t } = useTranslation(['layout'])
  const { handleSelectedTab, selectedTab } = usePackageCard()

  return (
    <IconButton
      onClick={() => {
        handleSelectedTab(tabKey)
      }}
      Icon={iconsByTab[tabKey]}
      text={t(`packages.list.button.${tabKey}`)}
      className={selectedTab === tabKey ? 'active' : undefined}
    />
  )
}

export default PackageCardButton
